"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _combinedDataEdit = _interopRequireDefault(require("@/views/maintain/devconfig/combinedDataEdit"));
var systemGroupApi = _interopRequireWildcard(require("@/api/systemGroup"));
var _combineDataList = _interopRequireDefault(require("./combineDataList"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  // name: "combinedData"
  components: {
    edit: _combinedDataEdit.default,
    cmDataList: _combineDataList.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      dataList: {
        list: [],
        total: 0
      },
      listPram: {
        keywords: null,
        page: 1,
        pageSize: this.$constants.page.limit[0]
      },
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建 1=编辑
        editData: {}
      },
      comDataListConfig: {
        visible: false,
        formData: {}
      }
    };
  },
  mounted: function mounted() {
    this.handlerGetList(this.listPram);
  },
  methods: {
    handlerSearch: function handlerSearch() {
      this.listPram.page = 1;
      this.handlerGetList(this.listPram);
    },
    handlerOpenEdit: function handlerOpenEdit(editData, isCreate) {
      isCreate === 0 ? this.editDialogConfig.editData = {} : this.editDialogConfig.editData = editData;
      this.editDialogConfig.isCreate = isCreate;
      this.editDialogConfig.visible = true;
    },
    handlerGetList: function handlerGetList(pram) {
      var _this = this;
      systemGroupApi.groupList(pram).then(function (data) {
        _this.dataList = data;
      });
    },
    handleDataList: function handleDataList(rowData) {
      if (rowData.formId <= 0) return this.$message.error('请先关联表单');
      this.comDataListConfig.formData = rowData;
      this.comDataListConfig.visible = true;
    },
    handleDelete: function handleDelete(rowData) {
      var _this2 = this;
      this.$confirm('确定删除当前数据', '提示').then(function () {
        systemGroupApi.groupDelete(rowData).then(function (data) {
          _this2.$message.success('删除数据成功');
          setTimeout(function () {
            _this2.handlerGetList(_this2.listPram);
          }, 800);
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetList(this.listPram);
    },
    handlerHideDialog: function handlerHideDialog() {
      var _this3 = this;
      setTimeout(function () {
        _this3.editDialogConfig.visible = false;
        _this3.handlerGetList(_this3.listPram);
      }, 800);
    }
  }
};